<template>
  <div>
    <h1 class="page-title">{{ $t("EditOffer.title") }}</h1>
    <div class="card card-transparent">
      <div class="card-block">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <offer-form v-if="dataReady" :entityId="entityId" :offerId="offerId"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OfferForm from './OfferForm'
import { mapGetters } from 'vuex'

export default {
  name: 'EditOffer',
  components: { OfferForm },
  data: function(){
    return {
      dataReady: false
    }
  },
  computed: {
    ...mapGetters({
      offer: 'offers/offer',
    }),
    entityId(){
      return this.$route.params.entity_id;
    },
    offerId(){
      return this.$route.params.offer_id;
    }
  },
  methods: {
    redirectToListPath(){
      this.$router.push({ name: "Offers", params: { entity_id: this.entityId }});
    }
  },
  mounted: async function(){
    var self = this
    await this.$store.dispatch('offers/getOffer', this.offerId)
      .then(() => {
        if(!this.$can('update', this.offer)){
          self.redirectToListPath();
          self.$store.dispatch('message/enable', { type: 'danger', content: this.$i18n.t('messages.offers.cant_edit_published_offer') })
        }
        self.dataReady = true
      })
      .catch(error =>{
        self.redirectToListPath();
        self.$store.dispatch('message/enable', { type: 'danger', content: error.response.data.error })
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/offers/EditOffer.vue